import { FC } from 'react';

import styled, { css } from '@mint-lib/styled';
import { Link } from '@mint/routing';

import { Truncation } from '@myn/mui';

import { LinkFieldProps } from '../types.js';

type Props = Pick<LinkFieldProps, 'value' | 'scale' | 'color' | 'linkProps'>;

const LinkVariant: FC<Props> = ({ value, scale, color, linkProps }) => {
  if (!value) {
    return null;
  }

  return (
    <Link {...linkProps}>
      <StyledTruncation $scale={scale} color={color}>
        {value}
      </StyledTruncation>
    </Link>
  );
};

export default LinkVariant;

const StyledTruncation = styled(Truncation)<{
  $scale: number;
}>`
  ${({ $scale }) => css`
    width: auto;
    text-align: right;
    text-transform: none;
    font-size: ${0.875 * $scale}rem;
    line-height: ${$scale}rem;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `}
`;
